import Catalog from "../catalog/Catalog"

const HomePage: React.FC = () => {
  return (
    <Catalog />
  )
}

export default HomePage;
